/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tier: NonNullable<unknown>, price: NonNullable<unknown> }} Domain_Manager_Addon_DescInputs */

const en_domain_manager_addon_desc = /** @type {(inputs: Domain_Manager_Addon_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`As a ${i?.tier} member, you can orchestrate multiple storefronts. Add extra domains to your fleet for just $${i?.price}/mo each.`)
};

const es_domain_manager_addon_desc = /** @type {(inputs: Domain_Manager_Addon_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Como miembro ${i?.tier}, puedes orquestar múltiples tiendas. Añade dominios adicionales a tu flota por solo $${i?.price}/mes cada uno.`)
};

const fr_domain_manager_addon_desc = /** @type {(inputs: Domain_Manager_Addon_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`En tant que membre ${i?.tier}, vous pouvez orchestrer plusieurs vitrines. Ajoutez des domaines supplémentaires à votre flotte pour seulement ${i?.price} $/mois chacun.`)
};

const de_domain_manager_addon_desc = /** @type {(inputs: Domain_Manager_Addon_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Als ${i?.tier}-Mitglied kannst du mehrere Storefronts orchestrieren. Füge deiner Flotte zusätzliche Domains für nur ${i?.price} $/Monat pro Stück hinzu.`)
};

/** @type {(inputs: Domain_Manager_Addon_DescInputs) => LocalizedString} */
const ja_domain_manager_addon_desc = en_domain_manager_addon_desc;

/** @type {(inputs: Domain_Manager_Addon_DescInputs) => LocalizedString} */
const zh_domain_manager_addon_desc = en_domain_manager_addon_desc;

/** @type {(inputs: Domain_Manager_Addon_DescInputs) => LocalizedString} */
const ar_domain_manager_addon_desc = en_domain_manager_addon_desc;

/** @type {(inputs: Domain_Manager_Addon_DescInputs) => LocalizedString} */
const id_domain_manager_addon_desc = en_domain_manager_addon_desc;

/** @type {(inputs: Domain_Manager_Addon_DescInputs) => LocalizedString} */
const it_domain_manager_addon_desc = en_domain_manager_addon_desc;

/** @type {(inputs: Domain_Manager_Addon_DescInputs) => LocalizedString} */
const ru_domain_manager_addon_desc = en_domain_manager_addon_desc;

/** @type {(inputs: Domain_Manager_Addon_DescInputs) => LocalizedString} */
const pt_domain_manager_addon_desc = en_domain_manager_addon_desc;

/** @type {(inputs: Domain_Manager_Addon_DescInputs) => LocalizedString} */
const ko_domain_manager_addon_desc = en_domain_manager_addon_desc;

/**
* | output |
* | --- |
* | "As a {tier} member, you can orchestrate multiple storefronts. Add extra domains to your fleet for just ${price}/mo each." |
*
* @param {Domain_Manager_Addon_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_manager_addon_desc = /** @type {((inputs: Domain_Manager_Addon_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Manager_Addon_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_manager_addon_desc(inputs)
	if (locale === "es") return es_domain_manager_addon_desc(inputs)
	if (locale === "fr") return fr_domain_manager_addon_desc(inputs)
	if (locale === "de") return de_domain_manager_addon_desc(inputs)
	if (locale === "ja") return ja_domain_manager_addon_desc(inputs)
	if (locale === "zh") return zh_domain_manager_addon_desc(inputs)
	if (locale === "ar") return ar_domain_manager_addon_desc(inputs)
	if (locale === "id") return id_domain_manager_addon_desc(inputs)
	if (locale === "it") return it_domain_manager_addon_desc(inputs)
	if (locale === "ru") return ru_domain_manager_addon_desc(inputs)
	if (locale === "pt") return pt_domain_manager_addon_desc(inputs)
	return ko_domain_manager_addon_desc(inputs)
});